// extracted by mini-css-extract-plugin
export default {"headerBar":"IJY2HJcqtaOJpKrhekZ7","header":"ou2bkUpMjIERSM0GD3D6","mainText":"hQS_82rtlIwKjxU4SYlF","recommendedSection":"Fzwtv8vY7dLRvFJzxXQm","pillToggle":"kkn5tt6eTl71BLMW6qO6"};